import { Role, User } from "@/models";
import { database } from "@/repositories/database.ts";
import { Collections } from "@/types/Collections.ts";
import { tenant } from "@/repositories/tenant.ts";

export const user = {
  getById: async (id: string) => {
    return database.get<User>(id, Collections.users);
  },
  getByEmail: async (email: string) => {
    const users = await database.queryDocuments<User>(
      Collections.users,
      "email",
      "==",
      email
    );
    if (!users) {
      return undefined;
    }
    if (users.length === 0) {
      return undefined;
    }
    return users[0];
  },
  create: async (user: Partial<User>) => {
    return database.create(user, Collections.users);
  },
  update: async (user: Partial<User>) => {
    return database.update(user, `${Collections.users}/${user.id}`);
  },
  subscribe: (id: string, callback: (doc: User | undefined) => void) => {
    return database.subscribeDocument<User>(id, Collections.users, callback);
  },
  getLinkedTenants: async (id: string, role: Role) => {
    // Attach tenants that user has access to
    let allowedTenants = [];
    if (role === "superAdmin") {
      allowedTenants = await tenant.listTenants();
    } else {
      allowedTenants = await tenant.listTenantsByUser(id);
    }
    return allowedTenants.filter((tenant) => !tenant.disabled);
  },
};
